import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { BaseListApiService } from '@common/api/base-list-api.service';
import { ResultApi } from '@common/api/result-api';
import { VboRatesApi } from '../../models/vbo-rates-api';

@Injectable({
    providedIn: 'root'
})
export class VboSuccessRateListApiService extends BaseListApiService<VboRatesApi>
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.resourceUrl = '/hist/vbo/dailyrates';
    }

    getDailyRates (range: string): Observable<ResultApi<VboRatesApi>>
    {
        return this.getAll(`${this.resourceUrl}?${range}`);
    }
}
